import apiClient from '../shared/services/apiClient';

/**
 * Sidebar product visibility (owner 2026-11-03): by default only products the user has are shown,
 * the rest go under "More products"; the user can pick and order what is shown (saved server-side).
 * Product ids match api MenuPrefsController::PRODUCTS.
 */

/** NAV_SECTIONS item → product id (null = always shown, e.g. overview / tickets). */
export function productIdOf(item) {
    if (item.key) return item.key; // evm, cdn, dns, domain, ssl, s3, webmail, llm
    const byPath = {
        '/dedicated': 'dedicated',
        '/containers': 'containers',
        '/host_shared/vhosts': 'host_shared',
        '/sites': 'sites',
        '/disk': 'disk',
        '/tm/streams': 'tm',
    };
    return byPath[item.path] || null;
}

const CACHE_KEY = 'userMenuPrefs';

export function cachedMenu() {
    try {
        return JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
    } catch (e) {
        return null;
    }
}

function cache(v) {
    try {
        localStorage.setItem(CACHE_KEY, JSON.stringify(v));
    } catch (e) { /* private mode */ }
}

export async function loadMenu() {
    const r = await apiClient.get('/api/user/ui/menu');
    if (!r.data?.success) throw new Error(r.data?.error || 'load failed');
    cache(r.data.data);
    return r.data.data;
}

/** shown = ordered product ids, or null to go back to the default. */
export async function saveMenu(shown, current) {
    const r = await apiClient.put('/api/user/ui/menu', { shown });
    if (!r.data?.success) throw new Error(r.data?.error || 'save failed');
    const next = { ...(current || {}), prefs: r.data.data?.prefs ?? null };
    cache(next);
    return next;
}

/** Ordered list of shown product ids for a menu state ({default, prefs}); null state = show everything. */
export function shownIds(state) {
    if (!state) return null;
    return state.prefs?.shown || state.default || null;
}
